var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      hover: "",
      items: _vm.items,
      fields: _vm.fields,
      "table-class": "text-nowrap",
      responsive: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (data) {
          return [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v("\n            " + _vm._s(data.item.name) + "\n        "),
            ]),
          ]
        },
      },
      {
        key: "cell(category)",
        fn: function (data) {
          return [_vm._v("\n        " + _vm._s(data.item.category) + "\n    ")]
        },
      },
      {
        key: "cell(strain)",
        fn: function (data) {
          return [_vm._v("\n        " + _vm._s(data.item.strain) + "\n    ")]
        },
      },
      {
        key: "cell(qoh)",
        fn: function (data) {
          return [_vm._v("\n        " + _vm._s(data.item.qoh) + "\n    ")]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }